import styled from 'styled-components';
import React, { useContext } from 'react';
import { QueryBuilder } from '@/components/query-builder';
import { TrackElementContext } from '@/features/editor/widgets/track-element/context';

export function TrackingRules() {
  const { qbContext } = useContext(TrackElementContext);

  return (
    <Wrapper>
      <QueryBuilder
        noCaption
        whereNotion="If"
        andNotion="Then"
        plusNotion="And Then"
        context={qbContext}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  .qb-row-wrapper {
    margin-top: 2rem;

    div[class*='vsly-small-select'] div[class*='control'] {
      min-width: 40px !important;
      max-width: 190px !important;
    }
  }

  div[class*='query-builder__Row'] {
    gap: 1rem !important;
  }

  .then-wrapper {
    margin-top: 1rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 2rem;
    padding-bottom: 2rem;
  }

  .then-input {
    min-width: 6rem;
    max-width: 6rem;
    text-align: center;
    padding-right: 0.2rem;
    padding-left: 0.2rem;
  }
`;
